module.exports = __webpack_public_path__ + "static/media/logo_white.14f68aae.png";